import * as React from 'react';
import "./checkbox.styles.scss";

export default function CheckboxHtml(props) {
    const {name, ...others} = props;
    return (
      <label className="checkbox-container">
        <input name={name? name:"checkbox"} type="checkbox" {...others}/>
        <span className="checkmark"/>
      </label>
    );
}